import React from 'react'
import '../FamilyIslandPrivacyPolicy/style.css'

const FamilyIslandTermsAndConditions = () => {
  const year = new Date().getFullYear()
  return (
    <div className="family-body">
      <main className="family-page">
        <header className="family-backbar">
          <div className="family-backbar-title">Energy Links for Family Island Terms and Conditions</div>
        </header>

        <section className="family-cards">
          <article className="family-card">
            <h2 className="family-card-title">Terms And Conditions</h2>
            <p className="family-details">Last updated: 27 May, 2026</p>
            <p className="family-details">
              Make sure to read these Terms and Conditions before you start using our Service.
            </p>
          </article>

          <article className="family-card">
            <h2 className="family-card-title">Interpretation and Definitions</h2>
            <div className="family-section-title">Interpretation</div>
            <p className="family-details">
              When you see a word with a capital letter, it has a particular meaning listed below. That meaning doesn’t
              change if the word is singular or plural.
            </p>
          </article>

          <article className="family-card">
            <h2 className="family-card-title">User Acknowledgment</h2>
            <p className="family-details">
              These Terms and Conditions govern your use of this Service and form the agreement between you and the
              Company. They outline the rights and responsibilities of all users in connection with the use of the Service.
            </p>
            <p className="family-details">
              You may use the Service only if you accept and follow these Terms and Conditions. They apply to everyone who
              visits or uses the Service.
            </p>
            <p className="family-details">
              When you use or access the Service, you agree to follow these Terms and Conditions. If you don’t agree with
              them, you are not permitted to access or use the Service.
            </p>
            <p className="family-details">
              By accessing or using the Service, you affirm that you are 18 years of age or older. Individuals under 18 are
              not authorized to use the Service.
            </p>
            <p className="family-details">
              Before using the Service, please make sure you’ve read and agreed to our Privacy Policy. It explains how we
              handle your personal information, how it’s used and shared, and what rights you have to protect your privacy.
            </p>
          </article>

          <article className="family-card">
            <h2 className="family-card-title">Usage Rules</h2>
            <p className="family-details">
              Please use the Service responsibly. Don’t try to break, disrupt, or misuse it in any way — including hacking,
              scraping, reverse engineering, or using it for anything illegal.
            </p>
          </article>

          <article className="family-card">
            <h2 className="family-card-title">Bonuses and Virtual Items</h2>
            <p className="family-details">
              Our Service might show links to rewards like coins, energy, or bonuses from other games or services. These
              rewards aren’t sold by us and don’t have any cash value. They may not always be available and can depend on
              the third party’s rules, your location, or timing.
            </p>
          </article>

          <article className="family-card">
            <h2 className="family-card-title">External Offers and Ads</h2>
            <p className="family-details">
              You may see ads or promotions while using the Service. Any interaction or deal you make with an advertiser is
              between you and them. We’re not responsible for any problems or losses that come from those offers. Some
              promotions might have rules or conditions, so be sure to check their terms first.
            </p>
          </article>

          <article className="family-card">
            <h2 className="family-card-title">Intellectual Property</h2>
            <p className="family-details">
              The Service and all its content, such as text, graphics, logos, and software, are owned by us or our licensors
              and are legally protected. You are not allowed to copy, alter, share, or create new works based on this content
              without our prior written consent.
            </p>
          </article>

          <article className="family-card">
            <h2 className="family-card-title">Service Changes</h2>
            <p className="family-details">
              We reserve the right to modify, suspend, or discontinue the Service, in whole or in part, at any time, with or
              without prior notice. The Company shall not be liable to you or any third party for any such modifications,
              suspensions, or discontinuations.
            </p>
          </article>

          <article className="family-card">
            <h2 className="family-card-title">External Website Links</h2>
            <p className="family-details">
              Our Service may include links to external websites or services that are independently operated and not managed
              by the Company.
            </p>
            <p className="family-details">
              The Company does not control and is not responsible for the content, privacy practices, or policies of these
              third-party sites. You agree that the Company cannot be held liable for any issues, damages, or losses that may
              arise from using or relying on their content, products, or services.
            </p>
            <p className="family-details">
              We recommend reviewing the terms, conditions, and privacy policies of any external websites or services you
              access through our Service.
            </p>
          </article>

          <article className="family-card">
            <h2 className="family-card-title">Account Suspension and Termination</h2>
            <p className="family-details">
              We reserve the right to suspend or terminate your access to the Service immediately, without prior notice or
              liability, for any reason, including if you violate these Terms and Conditions.
            </p>
            <p className="family-details">Once your access is terminated, your right to use the Service will end immediately.</p>
          </article>

          <article className="family-card">
            <h2 className="family-card-title">Limits on Liability</h2>
            <p className="family-details">
              Regardless of any damages you may incur, the total liability of the Company and its suppliers under these
              Terms, and your sole remedy, is limited to the amount you have paid through the Service, or $100 if you have
              not made any purchases.
            </p>
            <p className="family-details">
              To the fullest extent allowed by law, the Company and its suppliers are not responsible for any special,
              indirect, incidental, or consequential damages. This includes, but is not limited to, loss of profits, loss of
              data, business interruptions, personal injury, privacy loss, or any issues arising from third-party software or
              hardware used with the Service, even if advised of the possibility of such damages.
            </p>
            <p className="family-details">
              Some jurisdictions do not allow the exclusion of implied warranties or the limitation of certain damages. In
              such cases, the limitations above may not fully apply, and liability will be limited to the maximum extent
              permitted by law.
            </p>
          </article>

          <article className="family-card">
            <h2 className="family-card-title">Service Provided "As Is" and "As Available"</h2>
            <p className="family-details">
              The Service is provided to you "as is" and "as available," without any warranties of any kind. To the fullest
              extent allowed by law, the Company, its affiliates, licensors, and service providers disclaim all express,
              implied, statutory, or other warranties, including but not limited to warranties of merchantability, fitness for
              a particular purpose, title, non-infringement, and those arising from trade, course of dealing, or usage. The
              Company does not guarantee that the Service will meet your needs, achieve any intended results, work with other
              software or systems, operate continuously or reliably, or be free from errors that can or will be corrected.
            </p>
            <p className="family-details">
              Further, neither the Company nor its service providers make any promises regarding: (i) the operation,
              availability, or content of the Service; (ii) uninterrupted or error-free service; (iii) the accuracy,
              reliability, or timeliness of information or content provided; or (iv) that the Service, its servers, or
              communications from the Company are free from viruses, malware, or other harmful components.
            </p>
            <p className="family-details">
              Some jurisdictions may not allow the exclusion of certain warranties or limitations on consumer rights. In such
              cases, the above limitations may not fully apply, but they will still be enforced to the maximum extent
              permitted by law.
            </p>
          </article>

          <article className="family-card">
            <h2 className="family-card-title">Law That Applies</h2>
            <p className="family-details">
              This Agreement and your use of the Service are governed by the laws of the Country, without considering its
              conflict of law rules. Additionally, your use of the Application may be subject to other local, state,
              national, or international regulations.
            </p>
          </article>

          <article className="family-card">
            <h2 className="family-card-title">Resolving Disputes</h2>
            <p className="family-details">
              If you have any questions or disagreements regarding the Service, you agree to first attempt to resolve the
              matter informally by reaching out to the Company.
            </p>
          </article>

          <article className="family-card">
            <h2 className="family-card-title">EU Users’ Rights</h2>
            <p className="family-details">
              If you are a consumer residing in the European Union, you will be entitled to all mandatory legal protections
              provided by the laws of your country of residence.
            </p>
          </article>

          <article className="family-card">
            <h2 className="family-card-title">U.S. Legal Compliance</h2>
            <p className="family-details">
              By using the Service, you confirm that (i) you are not located in a country subject to U.S. government
              embargoes or designated as supporting terrorism, and (ii) you are not included on any U.S. government list of
              prohibited or restricted parties.
            </p>
          </article>

          <article className="family-card">
            <h2 className="family-card-title">Severability and Waiver</h2>
            <div className="family-section-title">Severability</div>
            <p className="family-details">
              If any part of these Terms is found to be invalid or unenforceable, it will be modified and interpreted to
              achieve its intended purpose as much as possible under the law. The remaining provisions will remain fully
              effective.
            </p>
            <div className="family-section-title">Waiver</div>
            <p className="family-details">
              Failing to enforce any right or requirement under these Terms does not prevent a party from exercising that
              right or requiring performance in the future. Similarly, waiving a breach does not constitute a waiver of any
              later breach.
            </p>
          </article>

          <article className="family-card">
            <h2 className="family-card-title">Translations and Language</h2>
            <p className="family-details">
              If these Terms and Conditions are offered in a language other than English, the English version will always
              govern and take priority in the event of any dispute.
            </p>
          </article>

          <article className="family-card">
            <h2 className="family-card-title">Updates to Terms and Conditions</h2>
            <p className="family-details">
              We may update or replace these Terms at any time at our sole discretion. For significant changes, we will try
              to provide at least 30 days' notice before the new terms take effect. What counts as a significant change will
              be decided by us.
            </p>
            <p className="family-details">
              By continuing to use our Service after the updates take effect, you agree to the revised terms. If you do not
              agree with any of the changes, please stop using the our Service.
            </p>
          </article>

          <article className="family-card">
            <h2 className="family-card-title">Contact</h2>
            <p className="family-details">
              For questions regarding these Terms and Conditions, contact us at: <a className="family-link" href="mailto:parth@aavakar.com"> parth@aavakar.com</a>
            </p>
          </article>
        </section>
      </main>
    </div>
  )
}

export default FamilyIslandTermsAndConditions

